import axios from 'axios'
import { Message, Notification } from "element-ui";
import router from '../router'

let baseUrl = process.env.domainUrl;

//请求超时时间
axios.defaults.timeout = 500000
//请求头
//axios.defaults.headers.post['Content-Type']='application/json'
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'

//请求拦截
axios.interceptors.request.use(
    config => {
        config.headers.authorization = localStorage.accessToken;
        // config.headers['Content-Type'] = 'application/x-www-form-urlencoded'
        // config.headers.Authorization  = 'Bearer '+localStorage.token;
        // config.headers.accessToken  = localStorage.accessToken;
        // config.headers.refreshToken = localStorage.refreshToken;
        return config
    },
    error => {
        return Promise.error(error)
    }
)
// axios.interceptors.request.use(
//     config => {
//         return config
//     },
//     error => {
//         return Promise.error(error)
//     }
// )

//响应拦截器
axios.interceptors.response.use(
    response => {
        // 如果返回的状态码为200，说明接口请求成功，可以正常拿到数据
        // 否则的话抛出错误
        if (response.data.code === 4010002) {
            window.localStorage.removeItem('userInfo')
            window.localStorage.removeItem('accessToken')
            window.localStorage.removeItem('refreshToken')
            router.push('/login')
        }
        if (response.status === 200) {
            if (response && response.data && (typeof response.data.code) === 'number' && response.data.code !== 200) {
                Notification.closeAll()
                Notification({
                    message: response.data.msg || response.data.message || '请求错误，请联系技术人员',
                    type: 'error'
                })
            }
            return Promise.resolve(response)
        } else {
            return Promise.reject(response)
        }
    },
    // 服务器状态码不是2开头的的情况
    // 这里可以跟你们的后台开发人员协商好统一的错误状态码
    // 然后根据返回的状态码进行一些操作，例如登录过期提示，错误提示等等

    error => {
        console.log(error)
        if (error.response.status) {
            switch (error.response.status) {
                // 401: 未登录
                // 未登录则跳转登录页面，并携带当前页面的路径
                // 在登录成功后返回当前页面，这一步需要在登录页操作
                //case 401:
                case 404:
                    Toast({
                        message: '网络请求不存在',
                        duration: 1500,
                        forbidClick: true
                    })
                    break
                case 400:
                    Toast({
                        message: '服务器繁忙',
                        duration: 1500,
                        forbidClick: true
                    })
                    break
                default:
                    Toast({
                        message: '其它提示',
                        duration: 1500,
                        forbidClick: true
                    })
            }
            return Promise.reject(error.response)
        }
    }
)
/**
  * post方法，对应post请求
  * @param {String} url [请求的url地址]
  * @param {Object} params [请求时携带的参数]
  */
export function post(url, params) {

    return new Promise((resolve, reject) => {
        axios.post(baseUrl + url, params).then(res => {
            if (res.data.data == 15) {
                location.href = '#/login'
            }
            resolve(res.data)
        }).catch(err => {
            console.log('err:', err)
            reject(err.data)
        })
    })
}
/**
 * get方法，对应get请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */

export function get(url, params = '') {
    return new Promise((resolve, reject) => {
        axios.get(baseUrl + url, {
            params
        }).then(res => {
            if (res.data.data == 15) {
                location.href = '#/login'
            }
            resolve(res.data)
        }).catch(err => {
            reject(err.data)
        })
    })
}
export function getId(url, params) {
    return new Promise((resolve, reject) => {
        axios.get(baseUrl + url + params).then(res => {
            if (res.data.data == 15) {
                location.href = '#/login'
            }
            resolve(res.data)
        }).catch(err => {
            reject(err.data)
        })
    })
}
/**
  * post方法，对应post请求
  * @param {String} url [请求的url地址]
  * @param {Object} params [请求时携带的参数]
  */
export function put(url, params) {
    return new Promise((resolve, reject) => {
        axios.put(baseUrl + url, params).then(res => {
            if (res.data.data == 15) {
                location.href = '#/login'
            }
            resolve(res)
        }).catch(err => {
            console.log('err:', err)
            reject(err.data)
        })
    })
}

export function blob(url, params) {
    return new Promise((resolve, reject) => {
        axios.defaults.responseType = "blob";
        axios.post(baseUrl + url, params).then(res => {
            axios.defaults.responseType = "json";
            if (res.data.data == 15) {
                location.href = '#/login'
            }
            resolve(res)
        }).catch(err => {
            axios.defaults.responseType = "json";
            reject(err.data)
        })
    })
}

export {
    baseUrl
}



// WEBPACK FOOTER //
// ./src/api/http.js